import React, { useEffect, useState } from "react";
import { Table, Modal, Button } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { useHistory } from "react-router-dom";
import { baseUrl, domainStudent } from "../../../../services/config";
import Pagination from "@material-ui/lab/Pagination";
import EditStudent from "../../ActiveStudents/EditStudent/EditStudent";

// import EditStudent from "./EditStudent/EditStudent";
import Paper from "@material-ui/core/Paper";
import { useSelector, useDispatch } from "react-redux";
import usePagination from "../../../../components/usePagination/usePagination";
import { useAlert } from "react-alert";
// import ViewStudent from "../Student/ViewStudent/ViewStudent";

const SearchStudent = () => {
  const authtoken = localStorage.getItem("userToken");
  const user = JSON.parse(localStorage.getItem("userDetails"));
  const history = useHistory();
  const alert = useAlert();
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage, setpostPerPage] = useState(10);
  const [editModal, seteditModal] = useState(false);
  const [searchtext, setsearchtext] = useState("");
  const [loading, setloading] = useState(false);

  const [AllStaff, setAllStaff] = useState([]);
  const [AllStudent, setAllStudent] = useState([]);
  const [selectedStudent, setselectedStudent] = useState({});
  const [allcampuses, setallcampuses] = useState([]);
  const [campusID, setcampusID] = useState("");
  const [error, setError] = useState("");
  const [allconcessions, setallconcessions] = useState([]);
  const [allhostel, setallHostel] = useState([]);
  const [allVehical, setallVehical] = useState([]);
  const [previousSchoolData, setPreviousSchoolData] = useState([]);

  const [defaulthol, setDefaulthol] = useState([]);
  const [defaultCon, setDefaultCon] = useState([]);
  const [defaultVel, setDefaultVel] = useState([]);
  const [defaultSchool, setDefaultSchool] = useState([]);
  const dispatch = useDispatch();
  let campusidget = useSelector((state) => state.campuses.setselectedcampusid);
  const [previousselectedcampus, setpreviousselectedcampus] = useState(
    campusidget
  );

  // Search Student States
  const [selectedSection, setselectedsection] = useState("");
  const [studentName, setStudentName] = useState(true);
  const [studentFather, setStudentFather] = useState(false);
  const [studentIdCard, setStudentIdCard] = useState(false);
  const [studentAddress, setStudentAddress] = useState(false);
  const [studentMobile, setStudentMobile] = useState(false);
  const [studentAdmNo, setStudentAdmNo] = useState(false);

  const [selected, setSelected] = useState("studentName");

  useEffect(() => {
    if (campusidget != "") {
      setpreviousselectedcampus(campusidget);
      getAllStudents("", campusidget);
    }
    // getAllCampus();
    getConcessionTypes();
    getHostelID();
    getVehicleID();
    getPreviousSchool();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const fdata = new FormData();

    fdata.append("student_name", studentName ? 1 : 0);
    fdata.append("student_father_name", studentFather ? 1 : 0);
    fdata.append("student_ID_card", studentIdCard ? 1 : 0);
    fdata.append("student_addess", studentAddress ? 1 : 0);
    fdata.append("student_mobile_no", studentMobile ? 1 : 0);
    fdata.append("student_admission_no", studentAdmNo ? 1 : 0);
  };

  const onRadioButtonClick = (e) => {
    const value = e.target.value;
    setSelected(e.target.value);
    if (value == "studentName") {
      setStudentName(true);
      setStudentFather(false);
      setStudentIdCard(false);
      setStudentAddress(false);
      setStudentMobile(false);
      setStudentAdmNo(false);
    }
    if (value == "studentFather") {
      setStudentName(false);
      setStudentFather(true);
      setStudentIdCard(false);
      setStudentAddress(false);
      setStudentMobile(false);
      setStudentAdmNo(false);
    }
    if (value == "studentIdCard") {
      setStudentName(false);
      setStudentFather(false);
      setStudentIdCard(true);
      setStudentAddress(false);
      setStudentMobile(false);
      setStudentAdmNo(false);
    }
    if (value == "studentAddress") {
      setStudentName(false);
      setStudentFather(false);
      setStudentIdCard(false);
      setStudentAddress(true);
      setStudentMobile(false);
      setStudentAdmNo(false);
    }
    if (value == "studentMobile") {
      setStudentName(false);
      setStudentFather(false);
      setStudentIdCard(false);
      setStudentAddress(false);
      setStudentMobile(true);
      setStudentAdmNo(false);
    }
    if (value == "studentAdmNo") {
      setStudentName(false);
      setStudentFather(false);
      setStudentIdCard(false);
      setStudentAddress(false);
      setStudentMobile(false);
      setStudentAdmNo(true);
    }
  };
  const onSectionChange = (id) => {
    setselectedsection(id);
  };

  const getConcessionTypes = () => {
    fetch(`${baseUrl}/concession`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            setallconcessions(data.payload);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("err", err);
      });
  };

  const getHostelID = async () => {
    await fetch(`${baseUrl}/hostel`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallHostel(data.payload);
      })
      .catch((err) => {
        console.log("hostel", err);
      });
  };

  const getVehicleID = async () => {
    await fetch(`${baseUrl}/vehicle`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallVehical(data.payload);
      })
      .catch((err) => {
        console.log("vehicle", err);
      });
  };

  const getPreviousSchool = async () => {
    await fetch(`${baseUrl}/previous-school`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setPreviousSchoolData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const getAllStudents = async (e, value) => {
    let id;
    let data;
    if (e) {
      id = e.target.value;
      setcampusID(id);
    } else {
      id = value;
    }
    dispatch({
      type: "SELECTED_CAMPUS_ID",
      payload: {
        setselectedcampusid: id,
      },
    });
    setpreviousselectedcampus(id);
    data = {
      campus_id: id,
      status: 2,
    };
  };
  const openEditDialog = (student) => {
    setDefaultCon([]);
    setDefaulthol([]);
    setDefaultVel([]);
    setDefaultSchool([]);
    setselectedStudent(student);
    if (student.concession_id != null) {
      const defaultValue = allconcessions.find(
        (item) => item.id == student.concession_id
      );
      setDefaultCon(defaultValue);
    }
    if (student.hostel_id != null) {
      const defaultValue = allhostel.find(
        (item) => item.id == student.hostel_id
      );
      setDefaulthol(defaultValue);
    }
    if (student.vehicle_id != null) {
      const defaultValue = allVehical.find(
        (item) => item.id == student.vehicle_id
      );
      setDefaultVel(defaultValue);
    }
    if (student.previous_school_id != null) {
      const defaultValue = previousSchoolData.find(
        (item) => item.id == student.previous_school_id
      );
      setDefaultSchool(defaultValue);
    }
    seteditModal(true);
  };
  const indexOfLastPost = currentPage * postPerPage;

  const indexOfFirstPost = indexOfLastPost - postPerPage;

  const dataSearch = AllStudent.filter((user) => {
    let text = searchtext.toLowerCase();
    return searchtext
      ? user.name?.toLowerCase().includes(text) ||
          user?.admission_id?.toLowerCase().includes(text) ||
          user?.father_name?.toLowerCase().includes(text) ||
          user?.father_cnic?.toLowerCase().includes(text) ||
          user?.address?.toLowerCase().includes(text) ||
          user?.mobile_no?.toLowerCase().includes(text)
      : true;
  });

  // const dataSearch = AllStudent.filter((user) => {
  //   let text = searchtext.toLowerCase();
  //   return searchtext
  //     ? user?.full_name?.toLowerCase().includes(text) ||
  //         user?.emp_code?.toLowerCase().includes(text)
  //     : true;
  // });
  const currentPosts = dataSearch.slice(indexOfFirstPost, indexOfLastPost);
  const paginate = (pagenumber) => setCurrentPage(pagenumber);

  let [page, setPage] = useState(1);
  const PER_PAGE = 10;

  const count = Math.ceil(dataSearch.length / PER_PAGE);
  const _DATA = usePagination(dataSearch, PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  const searchByCode = (e) => {
    e.preventDefault();
    if (searchtext == "") {
      alert.error("Please Enter Admission Id");
    } else {
      const data = {
        search_keyword: searchtext.toLocaleUpperCase(),
      };
      setloading(true);

      fetch(`${baseUrl}/search_by_adm_id`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authtoken}`,
        },

        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.metadata.success) {
            if (data.payload.length === 0) {
              alert.error("No Record Found!!");
              setloading(false);
            }
            const arr = data.payload;
            arr.forEach((item, i) => {
              item["Sr"] = i + 1;
            });
            setAllStudent(arr);
            // setAllStaff(arr);
            setloading(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg[0]);
              setloading(false);
            });
          }
        })
        .catch((err) => {
          console.log("No Record Found!!", err);
          setError("No Record Found!!");
        });
    }
  };

  const searchByName = (e) => {
    e.preventDefault();
    if (searchtext == "") {
      alert.error("Please Enter Student's Name");
    } else {
      const data = {
        search_keyword: searchtext.toLocaleUpperCase(),
      };
      setloading(true);

      fetch(`${baseUrl}/search_by_name`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authtoken}`,
        },

        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.metadata.success) {
            if (data.payload.length === 0) {
              alert.error("No Record Found!!");
              setloading(false);
            }
            const arr = data.payload;
            arr.forEach((item, i) => {
              item["Sr"] = i + 1;
            });
            setAllStudent(arr);
            // setAllStaff(arr);
            setloading(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg[0]);
              setloading(false);
            });
          }
        })
        .catch((err) => {
          console.log("No Record Found!!", err);
        });
    }
  };

  const searchByFather = (e) => {
    e.preventDefault();
    if (searchtext == "") {
      alert.error("Please Enter Father's Name");
    } else {
      const data = {
        search_keyword: searchtext.toLocaleUpperCase(),
      };
      setloading(true);

      fetch(`${baseUrl}/search_by_father_name`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authtoken}`,
        },

        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.metadata.success) {
            if (data.payload.length === 0) {
              alert.error("No Record Found!!");
              setloading(false);
            }
            const arr = data.payload;
            arr.forEach((item, i) => {
              item["Sr"] = i + 1;
            });
            setAllStudent(arr);
            // setAllStaff(arr);
            setloading(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg[0]);
              setloading(false);
            });
          }
        })
        .catch((err) => {
          console.log("Not Found", err);
        });
    }
  };

  const searchByID = (e) => {
    e.preventDefault();
    if (searchtext == "") {
      alert.error("Please Enter Father's ID Card");
    } else {
      const data = {
        search_keyword: searchtext.toLocaleUpperCase(),
      };
      setloading(true);

      fetch(`${baseUrl}/search_by_id_card`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authtoken}`,
        },

        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.metadata.success) {
            if (data.payload.length === 0) {
              alert.error("No Record Found!!");
              setloading(false);
            }
            const arr = data.payload;
            arr.forEach((item, i) => {
              item["Sr"] = i + 1;
            });
            setAllStudent(arr);
            // setAllStaff(arr);
            setloading(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg[0]);
              setloading(false);
            });
          }
        })
        .catch((err) => {
          console.log("Not Found", err);
        });
    }
  };

  const searchByAddress = (e) => {
    e.preventDefault();
    if (searchtext == "") {
      alert.error("Please Enter Student's Address");
    } else {
      const data = {
        search_keyword: searchtext.toLocaleUpperCase(),
      };
      setloading(true);

      fetch(`${baseUrl}/search_by_address`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authtoken}`,
        },

        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.metadata.success) {
            if (data.payload.length === 0) {
              alert.error("No Record Found!!");
              setloading(false);
            }
            const arr = data.payload;
            arr.forEach((item, i) => {
              item["Sr"] = i + 1;
            });
            setAllStudent(arr);
            // setAllStaff(arr);
            setloading(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg[0]);
              setloading(false);
            });
          }
        })
        .catch((err) => {
          console.log("Not Found", err);
        });
    }
  };

  const searchByMobile = (e) => {
    e.preventDefault();
    if (searchtext == "") {
      alert.error("Please Enter Student's Mobile No.");
    } else {
      const data = {
        search_keyword: searchtext.toLocaleUpperCase(),
      };
      setloading(true);

      fetch(`${baseUrl}/search_by_mobile_no`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authtoken}`,
        },

        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.metadata.success) {
            if (data.payload.length === 0) {
              alert.error("No Record Found!!");
              setloading(false);
            }
            const arr = data.payload;
            arr.forEach((item, i) => {
              item["Sr"] = i + 1;
            });
            setAllStudent(arr);
            // setAllStaff(arr);
            setloading(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg[0]);
              setloading(false);
            });
          }
        })
        .catch((err) => {
          console.log("Not Found", err);
        });
    }
  };

  // const loginAccount = JSON.parse(localStorage.getItem("userDetails")).role[0];

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        {/* <h1>Search Student</h1> */}
        <form onSubmit={handleSubmit}>
          <div className="row mt-4">
            <div className="col-sm-3 mt-2">
              <input
                checked={selected == "studentName"}
                onChange={(e) => onRadioButtonClick(e)}
                type="radio"
                id="StudentName"
                name="contact"
                value="studentName"
              />
              <label htmlFor="StudentName">Search by Name</label>
            </div>

            <div className="col-sm-3 mt-2">
              <input
                checked={selected == "studentFather"}
                onChange={(e) => onRadioButtonClick(e)}
                type="radio"
                id="StudentFather"
                name="contact"
                value="studentFather"
              />
              <label htmlFor="StudentFather">Search by Father Name</label>
            </div>

            <div className="col-sm-3 mt-2">
              <input
                checked={selected == "studentIdCard"}
                onChange={(e) => onRadioButtonClick(e)}
                type="radio"
                id="StudentIdCard"
                name="contact"
                value="studentIdCard"
              />
              <label htmlFor="StudentIdCard">Search by Father's ID Card</label>
            </div>

            <div className="col-sm-3 mt-2">
              <input
                checked={selected == "studentAddress"}
                onChange={(e) => onRadioButtonClick(e)}
                type="radio"
                id="StudentAddress"
                name="contact"
                value="studentAddress"
              />
              <label htmlFor="StudentAddress">Search by Address</label>
            </div>

            <div className="col-sm-3 mt-2">
              <input
                checked={selected == "studentMobile"}
                onChange={(e) => onRadioButtonClick(e)}
                type="radio"
                id="StudentMobile"
                name="contact"
                value="studentMobile"
              />
              <label htmlFor="StudentMobile">Search by Mobile No.</label>
            </div>

            <div className="col-sm-3 mt-2">
              <input
                checked={selected == "studentAdmNo"}
                onChange={(e) => onRadioButtonClick(e)}
                type="radio"
                id="StudentAdmNo"
                name="contact"
                value="studentAdmNo"
              />
              <label htmlFor="StudentAdmNo">Search by Admission No.</label>
            </div>
          </div>

          <div className="d-flex" style={{ flexWrap: "wrap" }}>
            {studentName ? (
              <div className="w-100">
                <div className="row mt-6">
                  <div className="col-md-5">
                    <input
                      onChange={(e) => setsearchtext(e.target.value)}
                      className="form-control"
                      placeholder="Enter Student Name"
                    />
                  </div>
                  <div className="col-md-4">
                    <button
                      type="submit"
                      onClick={searchByName}
                      className="btn btn-primary"
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            ) : null}

            {studentFather ? (
              <div className="w-100">
                <div className="row mt-6">
                  <div className="col-md-5">
                    <input
                      onChange={(e) => setsearchtext(e.target.value)}
                      className="form-control"
                      placeholder="Enter Student's Father Name"
                    />
                  </div>
                  <div className="col-md-4">
                    <button
                      type="submit"
                      onClick={searchByFather}
                      className="btn btn-primary"
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            ) : null}

            {studentIdCard ? (
              <div className="w-100">
                <div className="row mt-6">
                  <div className="col-md-5">
                    <input
                      onChange={(e) => setsearchtext(e.target.value)}
                      className="form-control"
                      placeholder="Enter Father's ID Card No. / CNIC No."
                    />
                  </div>
                  <div className="col-md-4">
                    <button
                      type="submit"
                      onClick={searchByID}
                      className="btn btn-primary"
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            ) : null}

            {studentAddress ? (
              <div className="w-100">
                <div className="row mt-6">
                  <div className="col-md-5">
                    <input
                      onChange={(e) => setsearchtext(e.target.value)}
                      className="form-control"
                      placeholder="Enter Student Address"
                    />
                  </div>
                  <div className="col-md-4">
                    <button
                      type="submit"
                      onClick={searchByAddress}
                      className="btn btn-primary"
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            ) : null}

            {studentMobile ? (
              <div className="w-100">
                <div className="row mt-6">
                  <div className="col-md-5">
                    <input
                      onChange={(e) => setsearchtext(e.target.value)}
                      className="form-control"
                      placeholder="Enter Father's Mobile No. / Phone No."
                    />
                  </div>
                  <div className="col-md-4">
                    <button
                      type="submit"
                      onClick={searchByMobile}
                      className="btn btn-primary"
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            ) : null}

            {studentAdmNo ? (
              <div className="w-100">
                <div className="row mt-6">
                  <div className="col-md-5">
                    <input
                      onChange={(e) => setsearchtext(e.target.value)}
                      className="form-control"
                      placeholder="Enter Student Admission Number"
                    />
                  </div>
                  <div className="col-md-4">
                    <button
                      type="submit"
                      onClick={searchByCode}
                      className="btn btn-primary"
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </form>
        {/* <tr id="tbl" style={{position:"sticky",top:"0",zIndex:"2",backgroundColor:"gainsboro"}}> */}
        <div className="mt-4" id="tableboot">
          <div>
            {/* <div className="makeITScrollAAble"> */}
            <Table
              style={{
                width: "150%",
                marginTop: "10px",
                overflowY: "scroll",
              }}
              responsive
            >
              <thead>
                {/* <tr id="tbl" style={{ position: "relative" }}> */}
                {/* <Table responsive className="mt-5">
          <thead>*/}
                <tr className="text-center">
                  <th style={{ textAlign: "center" }}>Sr. No</th>
                  <th style={{ textAlign: "center" }}>Adm. ID</th>
                  <th style={{ textAlign: "start" }}>Name</th>
                  <th style={{ textAlign: "start" }}>Father's Name</th>
                  <th style={{ textAlign: "center" }}>Status</th>
                  <th style={{ textAlign: "center" }}>Class</th>
                  <th style={{ textAlign: "center" }}>Section</th>
                  <th style={{ textAlign: "center" }}>DOB</th>
                  <th style={{ textAlign: "center" }}>CNIC_No</th>
                  <th style={{ textAlign: "center" }}>Mobile No</th>
                  <th style={{ textAlign: "center" }}>Adm. Date</th>
                  <th style={{ textAlign: "center" }}>Session</th>
                  <th style={{ textAlign: "center" }}>Addess</th>
                  <th style={{ textAlign: "center" }}>Edit</th>
                </tr>
              </thead>

              <tbody>
                {_DATA.currentData().map((student, index) => (
                  // key={index}
                  <tr key={student.id}>
                    <td>{student.Sr}</td>
                    {/* <td className="text_align_start ">{student.id}</td> */}
                    <td className="text_align_center">
                      {student.admission_id}
                    </td>
                    <td className="text_align_start">{student.name}</td>

                    <td style={{ textAlign: "start" }}>
                      {student.father_name}
                    </td>

                    {student.status == "1" ? (
                      <td style={{ textAlign: "center", color: "orange" }}>
                        {"Registered Only"}
                      </td>
                    ) : student.status == "2" ? (
                      <td style={{ textAlign: "center", color: "green" }}>
                        {"Admission Only"}
                      </td>
                    ) : student.status == "3" ? (
                      <td style={{ textAlign: "center", color: "orange" }}>
                        {"Applied For Admission"}
                      </td>
                    ) : student.status == "4" ? (
                      <td style={{ textAlign: "center", color: "red" }}>
                        {"Struck Off"}
                      </td>
                    ) : student.status == "5" ? (
                      <td style={{ textAlign: "center", color: "red" }}>
                        {"Pass Out"}
                      </td>
                    ) : student.status == "6" ? (
                      <td style={{ textAlign: "center", color: "red" }}>
                        {"Leaving"}
                      </td>
                    ) : student.status == "7" ? (
                      <td style={{ textAlign: "center", color: "red" }}>
                        {"Migrate"}
                      </td>
                    ) : null}

                    <td style={{ textAlign: "center" }}>
                      {student.student_class.name}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {student.global_section.name}
                    </td>
                    <td style={{ textAlign: "center" }}>{student.dob}</td>
                    <td style={{ textAlign: "center" }}>
                      {student.father_cnic}
                    </td>
                    <td style={{ textAlign: "center" }}>{student.mobile_no}</td>
                    <td style={{ textAlign: "center" }}>
                      {student.joining_date}
                    </td>

                    <td style={{ textAlign: "center" }}>
                      {student.session.year}
                    </td>
                    <td style={{ textAlign: "start" }}>{student.address}</td>
                    <td style={{ paddingLeft: "0px" }} className="text-center">
                      <a
                        key={index}
                        className="btn btn-icon btn-light btn-hover-primary btn-sm"
                        onClick={(e) => {
                          openEditDialog(student);
                        }}
                      >
                        <span
                          key={index}
                          className="svg-icon svg-icon-md svg-icon-primary"
                        >
                          <SVG
                            key={index}
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Communication/Write.svg"
                            )}
                          />
                        </span>
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>

        <div className="row justify-content-center">
          {loading && <span className="spinner-border"></span>}
        </div>

        <Pagination
          color="primary"
          count={count}
          size="large"
          page={page}
          variant="text"
          shape="round"
          onChange={handleChange}
        />
        <Modal onHide={() => seteditModal(false)} size="xl" show={editModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              {selectedStudent.name} {selectedStudent.admission_id}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <EditStudent
              defConce={defaultCon}
              defaulthol={defaulthol}
              defaultVel={defaultVel}
              defaultSchool={defaultSchool}
              reloader={() => onSectionChange()}
              show={() => seteditModal()}
              reload={() => getAllStudents()}
              onUpdateStudent={getAllStudents}
              studentDetail={selectedStudent}
            />
          </Modal.Body>
        </Modal>
      </Paper>
    </div>
  );
};

export default SearchStudent;
